import { Outlet } from 'react-router-dom'
import { AppShell } from '../AppShell/AppShell'

export function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
